import exiftool from "exiftool?raw";

export default exiftool;